export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const spaceRegExp = /^\S*$/;
export const onlySpaceRegExp = /^(?![ ]*$).*/;
export const noStartingSpaceRegExp = /^(?!\s).*/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
export const onlyAlphaNumericRegex = /^[A-Za-z0-9]+$/;
export const localPartForEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/;
export const domainRegex = /^(?!-)([a-zA-Z0-9-]{1,63}(?<!-)\.)+[a-zA-Z]{2,4}$/;
export const otpSixRegex = /^\d{6}$/;
export const tenRegex = /^\d{10}$/;
export const tenAlphaNumericRegex = /^[a-zA-Z0-9]{10}$/;
